export * from "./list-news-query"
export * from "./news-detail-query"
export * from "./create-news-mutation"
export * from "./news-detail-mutation"
